module.exports = new __parcel__URL__("Addresses_Icon.9226523f.svg").toString();